<form [formGroup]="form">
  <div class="row">
    <div class="col-12">
      <app-custom-input id="email" type="email"
                        [label]="'EMAIL_DATA.EMAIL' | translate"
                        [customFormGroup]="form"
                        [noteText]="'EMAIL_DATA.FIELD_ERROR.REQUIRED' | translate"
                        [attr.data-cy]="testIdPrefix + 'email'">
      </app-custom-input>
    </div>
  </div>
</form>
